import api from './axiosConfig';

export interface FetchHVACampaignPerformanceParams {
  bxpcampaignid: number;
  datefrom?: string;
  dateto?: string;
}

export interface CallResultFilters {
  phoneResult?: string;
  resultadoPositivo?: number;
  minDuration?: number;
  maxDuration?: number;
  customerRef?: string;
  phoneNumber?: string;
}

export interface FetchHVACallResultsParams {
  bxpcampaignid: number;
  startDate?: string;
  endDate?: string;
  filters?: CallResultFilters;
}

// Obtiene los datos para el informe de resultados de una campaña
export const fetchHVACampaignPerformanceData = async (
  params: FetchHVACampaignPerformanceParams
) => {
  try {
    const response = await api.post('hvareporting/campaignperformance', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA Campaign Performance Data:', error);
    throw error;
  }
};

// Obtiene los datos de resultados de llamadas para una campaña específica
export const fetchHVACallResultsData = async (
  params: FetchHVACallResultsParams
) => {
  try {
    const response = await api.post('hvareporting/callresults', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA Call Results Data:', error);
    throw error;
  }
};
